module.exports = __webpack_public_path__ + "static/media/dot-purple.de8aacf7.svg";